import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UtilSessionStorageService {
    public getReferralCode(): string | null {
        return sessionStorage.getItem('referralCode');
    }

    public setReferralCode(referralCode: string): UtilSessionStorageService {
        if (referralCode && referralCode.length > 0) {
            sessionStorage.setItem('referralCode', referralCode);
        }
        return this;
    }

    public clearReferralCode(): void {
        sessionStorage.removeItem('referralCode');
    }
}
